import { render } from "./Rules.vue?vue&type=template&id=395d454c"
const script = {}

import "./Rules.vue?vue&type=style&index=0&id=395d454c&lang=scss"

import exportComponent from "D:\\Server\\Projects\\aurus-applications-support\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__